import styles from './banner.module.css';

const Banner = ({ icon, title, text, onReviewClick, endComponent, variant = 'primary' }) => {

  return (
    <div className={variant === 'primary' ? styles.bannerContainer : styles.bannerContainerSecondary}>
      <div className={variant === 'primary' ? styles.iconTextContainer : styles.iconTextContainerSecondary}>
        <div className={variant === 'primary' ? styles.iconContainer : styles.iconContainerSecondary}>
          {icon}
        </div>
        <div className={styles.textContainer}>
            <div className={variant === 'primary' ? styles.spanText : styles.spanTextSecondary} onClick={onReviewClick}>
              {title}
            </div>
          <p>
            {text}
          </p>
        </div>
      </div>
      <div className={styles.actionsContainer}>
        {endComponent}
      </div>
    </div>
  );
};

export default Banner;
